import { render, staticRenderFns } from "./AgregarCliente.vue?vue&type=template&id=e8f6bc54&"
import script from "./AgregarCliente.vue?vue&type=script&lang=js&"
export * from "./AgregarCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports